export default {
  engagementAnswerGalleries(state) {
    return state.engagementAnswerGalleries;
  },
};
